import { ErrorsService } from "common";
import { forkJoin, Observable } from "rxjs";
import { readOnly, readWrite } from "../../user/user-permission/user-permission.data";
import { UserPermissionService } from "../../user/user-permission/user-permission.service";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export class AccountPledgeGuard implements CanActivate {
  constructor(
    private readonly errorsService: ErrorsService,
    private readonly userPermissionService: UserPermissionService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return forkJoin([
      this.userPermissionService.granted([readWrite('servicing-account-facilities')]),
      this.userPermissionService.granted([readOnly('admin-facilities')])
    ]).pipe(
      map((result: boolean[]) => {
        const hasPermissions = result.every(value => value);
        if (!hasPermissions) {
          this.errorsService.showForbiddenErrorPage();
        }
        return hasPermissions;
      })
    )
  }
}